module.exports = __webpack_public_path__ + "img/city-large.7ce72c5d.png";